// extracted by mini-css-extract-plugin
module.exports = {"applicationsPrompt":"cams_applicationsPrompt__D3M9l","hideOnMobile":"cams_hideOnMobile__8mLyj"};